/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SOffenderRecordsReport
 */
export interface SOffenderRecordsReport {
    /**
     * 
     */
    report_s3_key?: string;
    /**
     * 
     */
    report_access_url?: string;
}

/**
 * Check if a given object implements the SOffenderRecordsReport interface.
 */
export function instanceOfSOffenderRecordsReport(value: object): value is SOffenderRecordsReport {
    return true;
}

export function SOffenderRecordsReportFromJSON(json: any): SOffenderRecordsReport {
    return SOffenderRecordsReportFromJSONTyped(json, false);
}

export function SOffenderRecordsReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): SOffenderRecordsReport {
    if (json == null) {
        return json;
    }
    return {
        
        'report_s3_key': json['report_s3_key'] == null ? undefined : json['report_s3_key'],
        'report_access_url': json['report_access_url'] == null ? undefined : json['report_access_url'],
    };
}

export function SOffenderRecordsReportToJSON(json: any): SOffenderRecordsReport {
    return SOffenderRecordsReportToJSONTyped(json, false);
}

export function SOffenderRecordsReportToJSONTyped(value?: SOffenderRecordsReport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'report_s3_key': value['report_s3_key'],
        'report_access_url': value['report_access_url'],
    };
}

